import { createReducer } from 'redux-starter-kit';
import { putVehicleDiagrams } from './vehicleDiagramActions';


/**
 * A selector for the vehicle diagrams in the domain.
 * @param {state} state The redux state for the application.
 */
export const selectVehicleDiagramMap = state => state.via.domain.vehicleDiagrams;

// A dict object with a proprty key of: vehicleDiagramCode and a propertyValue of: vehicleDiagram.
const initialVehicleDiagramState = {
  // vehicleDiagramCode: { /* vehicleDiagram */ }
  // vehicleDiagramCode: { /* vehicleDiagram */ }
  // ...etc
};

/**
 * A reducer that handles action for the Model Type domain.
 */
const vehicleDiagramsReducer = createReducer(initialVehicleDiagramState, {
  // Inserts/Updates all the model types.
  [putVehicleDiagrams]: (state, action) => {
    const vehicleDiagrams = action.payload;
    // Converts the array of vehicleDiagrams into a dict object mapping the id to the vehicle diagram.
    // { vehicleDiagramId: { /* vehicleDiagram */ }, vehicleDiagramId: { /* vehicleDiagram */ }, ...etc}
    return vehicleDiagrams.reduce((newState, vehicleDiagram) => {
      newState[vehicleDiagram.vehicleDiagramCode] = vehicleDiagram; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...state });
  },

});

export default vehicleDiagramsReducer;
